import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCkVSeQ0Jguu3_4MN4zWCPfG0Pvq2xSFBU",
  authDomain: "class-timer.firebaseapp.com",
  projectId: "class-timer",
  storageBucket: "class-timer.appspot.com",
  messagingSenderId: "997767349429",
  appId: "1:997767349429:web:ff93306f1efb6c141a6afc",
};

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
export const firestore = firebase.firestore;
export const db = firebase.firestore();
export const googleProvider = new firebase.auth.GoogleAuthProvider();
export const fbProvider = new firebase.auth.FacebookAuthProvider();
export const appleProvider = new firebase.auth.OAuthProvider("apple.com");
